import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { bem } from 'helpers/class-name';
import { makeValidators } from '../helpers';

import './Checkbox.scss';

const { block, element } = bem('hook-form-checkbox');

const Checkbox = props => {
  const { children, className, disabled, name, margin } = props;
  const { register } = useFormContext();
  const intl = useIntl();
  const validators = makeValidators(props, intl);

  return (
    <label className={block(className, { margin })}>
      <input
        {...register(name, { ...validators })}
        type="checkbox"
        disabled={disabled}
        className={element('input', { disabled })}
      />
      <div className={element('label', { disabled })}>{children}</div>
    </label>
  );
};

Checkbox.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  margin: PropTypes.bool,
  name: PropTypes.string.isRequired,
};

export default Checkbox;
